<script lang="ts" setup>
	import { Instagram, MessageCircle, Send } from "lucide-vue-next";

	const socialIcons = [
		{
			name: "Instagram",
			component: Instagram,
			href: "https://www.instagram.com/sednacollege?igsh=MWxsZnBnNnlxNDk0aw==",
		},
		// { name: "WhatsApp", component: MessageCircle, href: "#" },
		{
			name: "Bale",
			component: "img",
			src: "/images/bale-border.svg",
			href: "https://ble.ir/sedna_language",
		},
		{
			name: "Telegram",
			component: Send,
			href: "https://t.me/sedna_language",
		},
	];
</script>

<template>
	<div class="w-full z-0 flex flex-col gap-4 md:gap-0">
		<div class="flex flex-row justify-between items-center gap-6">
			<!-- Navigation Links -->
			<div class="order-2 flex flex-row gap-4">
				<button
					class="outline-gray-300 rounded-full hover:text-primary transition-colors text-sm"
					@click="navigateTo('/tv')"
				>
					تماشا با تلویزون
				</button>
				<button
					class="outline-gray-300 rounded-full hover:text-primary transition-colors text-sm"
					@click="navigateTo('/about')"
				>
					درباره سدنا
				</button>
				<button
					class="outline-gray-300 rounded-full hover:text-primary transition-colors text-sm"
					@click="navigateTo('/contact')"
				>
					تماس با ما
				</button>
			</div>
			<!-- Logo -->
			<div
				class="order-1 my-2 z-1 cursor-pointer"
				@click="navigateTo('/')"
			>
				<img
					alt="sedna"
					class="flex justify-center items-center h-10"
					src="/images/white_sedna_world_logo.svg"
				/>
				<!--            <SednaLogo class="text-white" />-->
			</div>
		</div>
		<!-- Divider -->
		<!--      <div class="border-t border-gray-700 my-1" />-->
		<!-- Bottom Section -->
		<div
			class="h-fit flex md:flex-row flex-col md:justify-between items-center md:gap-4 gap-4 mb-2"
		>
			<!-- Social Icons -->
			<div class="flex gap-4 order-1 md:order-3">
				<a
					v-for="(icon, index) in socialIcons"
					:key="index"
					:href="icon.href"
					class="hover:text-gray-300 transition-colors outline-gray-300"
				>
					<img
						v-if="icon.component === 'img'"
						:src="icon.src"
						:alt="icon.name"
						class="h-6 w-6"
					/>
					<component :is="icon.component" v-else class="h-6 w-6" />
					<span class="sr-only">{{ icon.name }}</span>
				</a>
			</div>
			<!-- Copyright Text -->
			<div class="order-2">
				<p
					class="justify-center items-center text-sm text-white text-justify font-light"
				>
					کلیه حقوق مادی و معنوی این وب‌سایت محفوظ و متعلق به سدنا
					می‌باشد.
				</p>
			</div>
			<!-- Design by Text -->
			<div
				class="text-white order-3 md:order-1 text-sm font-light whitespace-nowrap"
			>
				طراحی و توسعه توسط
				<button
					class="outline-gray-300 h-6 rounded-full text-infoBlue cursor-pointer"
					@click="
						navigateTo('https://cyclops.vision', {
							external: true,
						})
					"
				>
					سرو
				</button>
			</div>
		</div>
	</div>
</template>
